import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
 private socket!: Socket;
  private isConnected = false;
  apiUrl = environment.webSocket;

 //private initSocket() {
 //  if (this.socket) return;
 //  const storedData = localStorage.getItem("authUser");
 //  if (!storedData) return;
 //  const parsedData = JSON.parse(storedData);
 //  const token = parsedData.token;
 //  this.socket = io(this.apiUrl, {
 //    transports: ['websocket'],
 //    auth: { token }
 //  });
 //  this.socket.on('connect', () => {
 //    console.log('Connected with ID:', this.socket.id);
 //    this.isConnected = true;
 //  });
 //  this.socket.on('disconnect', () => {
 //    console.warn('Disconnected');
 //    this.isConnected = false;
 //  });
 //  this.socket.on('connect_error', (err) => {
 //    console.error('Connection error:', err);
 //  });
 //}

 private initSocket() {
  if (this.socket?.connected) return;

  const useTokenAuth = environment.useTokenAuth;

  let socketOptions: any = {
    transports: ['websocket']
  };

  // DEV → Token Auth
  if (useTokenAuth) {

    const storedData = localStorage.getItem('authUser');

    if (!storedData) {
      console.warn('No authUser found');
      return;
    }

    try {
      const parsedData = JSON.parse(storedData);
      const token = parsedData.token;

      socketOptions.auth = { token };

    } catch (err) {
      console.error('Token parse error:', err);
      return;
    }

  } 
  // TEST / LIVE → Cookie Auth
  else {

    socketOptions.withCredentials = true;

  }

  console.log('Socket init:', this.apiUrl);
  console.log('Socket options:', socketOptions);

  this.socket = io(this.apiUrl, socketOptions);

  this.socket.on('connect', () => {
    console.log('Connected with ID:', this.socket.id);
    this.isConnected = true;
  });

  this.socket.on('disconnect', () => {
    console.warn('Disconnected');
    this.isConnected = false;
  });

  this.socket.on('connect_error', (err) => {
    console.error('Connection error:', err);
  });
}

  private fromSocketEvent<T>(eventName: string): Observable<T> {
  this.initSocket();

  return new Observable<T>((observer) => {

    if (!this.socket) {
      console.warn('Socket not initialized');
      return;
    }

    const handler = (data: T) => {
      //console.log(`${eventName} empfangen:`, data);
      observer.next(data);
    };

    this.socket.on(eventName, handler);

    // 🔥 wichtig: cleanup
    return () => {
      this.socket.off(eventName, handler);
    };
  });
}

onNewEvent(): Observable<any> {
  return this.fromSocketEvent('new_event');
}

onUpdateEvent(): Observable<any> {
  return this.fromSocketEvent('update_event');
}

onDeleteEvent(): Observable<any> {
  return this.fromSocketEvent('delete_event');
}

onNewTemplate(): Observable<any> {
  return this.fromSocketEvent('insert_template');
}

onUpdateTemplate(): Observable<any> {
  return this.fromSocketEvent('update_template');
}

onDeleteTemplate(): Observable<any> {
  return this.fromSocketEvent('delete_template');
}

onNewInvalid(): Observable<any> {
  return this.fromSocketEvent('new_invalid');
}

onDeleteInvalid(): Observable<any> {
  return this.fromSocketEvent('delete_invalid');
}

onErrorCountUpdate(): Observable<any> {
  return this.fromSocketEvent('calendar:errorCountUpdate');
}

onResourceUpdate(): Observable<any> {

  this.initSocket();

  return new Observable(observer => {

    if (!this.socket) return;

    const handler = (data: any) => {
      //console.log('resource update empfangen:', data);
      observer.next(data);
    };

    this.socket.on('update_resources', handler);
    this.socket.on('delete_resources', handler);

    return () => {
      this.socket.off('update_resources', handler);
      this.socket.off('delete_resources', handler);
    };
  });
}

onStatsUpdate(): Observable<any> {
  return this.fromSocketEvent('stats_update');
}

  // private socket!: Socket;
  // apiUrl = environment.webSocket; 
  // storedData = localStorage.getItem("authUser");

  // connect(): void {
  //   if(this.storedData) {
  //     const parsedData = JSON.parse(this.storedData);
  //     const token = parsedData.token;

  //     this.socket = io(this.apiUrl, {
  //       transports: ['websocket'],
  //       auth: {
  //         token: token,
  //       },
  //     });

  //     console.log(this.socket);

  //     this.socket.on('connect', () => {
  //       console.log('Connected to WebSocket with ID:', this.socket.id);
  //     });

  //     this.socket.on('connect_error', (err) => {
  //       console.error('Connection error:', err);
  //     });
      
  //     this.socket.on('disconnect', () => {
  //       console.warn('Disconnected from WebSocket');
  //     });
  //   }
  // }

  // onNewEvent(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('new_event', (event) => {
  //      console.log('new_event empfangen:', event); 
  //       observer.next(event);
  //     });
  //   });
  // }

  // onUpdateEvent(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('update_event', (event) => {
  //      console.log('update_event empfangen:', event); 
  //       observer.next(event);
  //     });
  //   });
  // }

  // onDeleteEvent(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('delete_event', (event) => {
  //       console.log('delete_event empfangen:', event); 
  //       observer.next(event);
  //     });
  //   });
  // }

  // onNewTemplate(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('insert_template', (template) => {
  //       console.log('new_template empfangen:', template); 
  //       observer.next(template);
  //     });
  //   });
  // }

  // onUpdateTemplate(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('update_template', (template) => {
  //       console.log('update_template empfangen:', template); 
  //       observer.next(template);
  //     });
  //   });
  // }

  // onDeleteTemplate(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('delete_template', (template) => {
  //       console.log('delete_template empfangen:', template); 
  //       observer.next(template);
  //     });
  //   });
  // }

  // onNewInvalid(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('new_invalid', (invalid) => {
  //       console.log('new_invalid empfangen:', invalid); 
  //       observer.next(invalid);
  //     });
  //   });
  // }

  // onDeleteInvalid(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('delete_invalid', (invalid) => {
  //       console.log('delete_invalid empfangen:', invalid); 
  //       observer.next(invalid);
  //     });
  //   });
  // }

  // onResourceUpdate(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on('update_resources', (resources) => {
  //       console.log('update_resources empfangen:', resources); 
  //       observer.next(resources);
  //     });
  //     this.socket.on('delete_resources', (resources) => {
  //       console.log('delete_resources empfangen:', resources); 
  //       observer.next(resources);
  //     });
  //   });
  // }

  //   onErrorCountChanged(): Observable<any> {

  //   this.initSocket(); // 🔥 wichtig

  //   return new Observable(observer => {

  //     if (!this.socket) {
  //       console.warn('Socket not initialized');
  //       return;
  //     }

  //     this.socket.on('calendar:errorCountChanged', (data) => {
  //       console.log('calendar:errorCountChanged empfangen:', data);
  //       observer.next(data);
  //     });

  //     return () => {
  //       this.socket.off('calendar:errorCountChanged');
  //     };
  //   });
  // }



}